<template>
    <div
            class="dashboard-settings-line"
            :class="[{collapsed:!isShowTopPanel},`dashboard-settings-line_${dashboardType.toLowerCase()}`]"
    >
        <template v-if="dashboardType.toLowerCase() === 'source'">
            <div
                    class="dashboard-row dashboard-row_first"
                    :class="{collapsed:!isShowTopPanel}"
            >
                <VFilterAttributes
                        v-if="sourceGroups"
                        :options="sourceGroups"
                        :current-source-name=currentBoard.currentSource.name
                        :all-features="allFeatures"
                        :displayed-active-features-names="currentBoard.currentSource.displayedActiveFeaturesNames"
                        v-model="selectedFeatures"
                        ref="filterattributes"
                        @updateFeatures="updateFeatures"
                        @updateTempCurrentSourceEventsNames="updateTempCurrentSourceEventsNames"
                />
                <EventsBlock
                        :events="boards[activeBoardIndex].events"
                        :events-order.sync="boards[activeBoardIndex].eventsOrder"
                        :show-name="'Events'"
                        :all-events="allEvents"
                        :current-source-events="currentBoard.currentSource.events"
                        :current-board-all-events="currentBoard.allEvents"
                        :saved-data="savedData"
                        :temp-current-source-events-names="tempCurrentSourceEventsNames"
                        :session-events-order.sync="sessionEventsOrder"
                        @updateEvents="updateEvents"
                        @swapEvents="swapEvents"
                        @showTooltip="showTooltip"
                ></EventsBlock>
            </div>
            <div
                    class="dashboard-row dashboard-row_second"
                    :class="{collapsed:!isShowTopPanel}"
            >
                <div
                        class="dashboard-row_second-hidden"
                >
                    <VFilter
                            v-if="allProjects"
                            :options="allProjects"
                            :is-show-search="true"
                            :filter-properties="['bundle_id','title']"
                            v-model="currentBoard.projects"
                            :is-grouped="true"
                            show-property="title"
                            unique-property="bundle_id"
                            group-label="org_name"
                            imageProperty="logo_small"
                            items-type="images"
                            @closed="updateDashboardData('VFilter-allProjects',true)"
                            @showTooltip="showTooltip"
                    >
                        Apps: <span class="VFilter-count"> {{ currentBoard.projects.length }}/{{
                        allProjects.length
                        }}</span>
                    </VFilter>
                    <VDateTimeSelectPicker
                            :presets="presets"
                            :history="currentBoard.componentsSettings.dateTimeHistory"
                            :dates="boards[activeBoardIndex].datePeriod"
                            @change="updateDateTimePickerAndSaveHistory"
                            @returnDateFromHistory="returnDateFromHistory"
                    ></VDateTimeSelectPicker>
                    <FormulasBlock
                            :formulas="currentBoard.formulas"
                            :templates="formulasTemplates"
                            :all-events="allEvents"
                            :is-show-top-panel="isShowTopPanel"
                            :current-board="currentBoard"
                            :boards="boards"
                            @addAllFormulas="addAllFormulas"
                            @addCurrentFormula="addCurrentFormula"
                            @deleteCurrentFormula="deleteCurrentFormula"
                            @updateCurrentFormula="updateCurrentFormula"
                            @updateCurrentFormulaName="updateCurrentFormulaName"
                            @updateStateForBoards="updateStateForBoards('FormulasBlock')"
                            @swapFormulas="swapFormulas"
                    >
                    </FormulasBlock>

                    <FiltersBlock
                            :filters="boards[activeBoardIndex].filters"
                            :sync="false"
                            @remove="removeFilter"
                            @clearAllFilters="clearAllFilters"
                            @showTooltip="showTooltip"
                    ></FiltersBlock>
                    <VToggle
                            v-model="boards[activeBoardIndex].cohort"
                            @click="updateCohort"
                            label="Cohorts"
                            class="VToggle"
                            is-vertical
                    ></VToggle>
                    <VToggle
                            v-model="boards[activeBoardIndex].sandbox"
                            @click="updateSandbox"
                            label="Sandbox"
                            class="VToggle"
                            is-vertical
                    ></VToggle>
                    <div
                            class="dashboard-refresh"
                            v-show="featureFiltersId == null"
                            @click="updateDashboardData('dashboard-refresh',true,true)"
                    >
                    </div>

                    <div
                            class="dashboard-refresh_filter"
                            v-show="featureFiltersId !== null"
                            @click="prepareFeatureFilter"
                    >
                    </div>
                    <div
                            class="dashboard-top-panel-switcher"
                            @click="changeTopPanelVisibillity"
                            :class="{'dashboard-top-panel-switcher_active': !isShowTopPanel}"
                    >
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import {changeFeaturesWidthOnColumnWidth} from './FeaturesBlock/calcs';
import FormulasBlock from '../Dashboard/FormulasBlock';
import EventsBlock from '../Dashboard/EventsBlock';
import FiltersBlock from '../Dashboard/FiltersBlock';
import {isIncludesAll} from '@/helpers/dataHelper';
import defaultTemplates from '../Dashboard/FormulasBlock/FormulasTemplates.json';
import {
    addFormulaToFeatures,
    swapFeaturesColumns,
    updateFeatureFormulaColumn,
} from './mapping';
import VFilterAttributes from '../../components/VFilterAttributes';
import {getSourceGroups, getFeaturesWithData} from '../../api/apiServices';
import {updateTimeHistory} from '../../helpers/dateTimeHelper';

export default {
    name: 'TopMenu',
    components: {
        VFilterAttributes,
        EventsBlock,
        FiltersBlock,
        FormulasBlock,
    },
    props: {
        dashboardType: {
            type: String,
            required: true,
        },
        currentBoard: {
            type: Object,
            required: true,
        },
        isShowTopPanel: {
            type: Boolean,
            required: true,
        },
        isEditingSettingsDisabled: {
            type: Boolean,
            required: true,
        },
        allProjects: {
            type: Array,
            required: true,
        },
        allEvents: {
            type: Array,
            required: true,
        },
        allFeatures: {
            type: Array,
            required: true,
        },
        boards: {
            type: Array,
            required: true,
        },
        savedData: {
            type: Object,
            required: true,
        },
        activeBoardIndex: {
            type: Number,
            required: true,
        },
        isEditMode: {
            type: Boolean,
            required: true,
        },
        presets: {
            type: Array,
            required: true,
        },
        featureFiltersId: {
            type: Number,
            required: false,
        },
        isFeaturesUpdating: {
            type: Boolean,
            required: true,
        },
        allEventsAndAllFormulas: {
            type: Array,
            required: true,
        },
        featuresSettings: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            sourceGroups: null,
            selectedFeatures: [],
            tempCurrentSourceEventsNames: [],
            sessionEventsOrder: [],
            formulasTemplates: [],
        };
    },
    created() {
        const revenueTemplates = [];
        _.cloneDeep(this.allEvents).map(event => {
          if (event.name.startsWith("revenue") && event.name.length > 7) {
            const number = event.name.match(/\d+/)[0];
            revenueTemplates.push({
              equation:`100*(${event.name}*coef-expense)/expense`,
              isActive:true,
              isTemplate:true,
              name:`romi${number}`,
            });
          }
        });
        revenueTemplates.sort((a, b) => {
          const numberA = parseInt(a.name.match(/\d+/)[0], 10);
          const numberB = parseInt(b.name.match(/\d+/)[0], 10);
          return numberA - numberB;
        });
        this.formulasTemplates = revenueTemplates.concat(_.cloneDeep(defaultTemplates));

        this.initClearData();
        this.createEventListeners();
    },
    beforeDestroy() {
        this.removeEventListeners();
    },
    watch: {
        'currentBoard.features': {
            immediate: true,
            handler(features) {
                this.generateSourceGroups(features);
            },
        },
        isFeaturesUpdating: {
            immediate: true,
            handler(isUpdating) {
                if (isUpdating) {
                    this.sessionEventsOrder = Object.freeze(_.cloneDeep(this.currentBoard.eventsOrder));
                }
            },
        },
    },
    methods: {
        initClearData() {
            this.deletedFormulasIndex = 0;
        },
        generateSourceGroups(features) {
            const featuresNames = features.map((feature) => feature.name);
            this.sourceGroups = _.cloneDeep(getSourceGroups()).map((group) => {
                const filteredFeatures = [];
                group.features.forEach((featureName) => {
                    filteredFeatures.push({
                        name: featureName.trim(),
                        isActive: featuresNames.includes(featureName.trim()),
                    });
                });
                group.features = filteredFeatures;
                return group;
            });
        },
        updateTempCurrentSourceEventsNames(chosenSource) {
            this.tempCurrentSourceEventsNames = Object.freeze(chosenSource.events.map((event) => event.name));
        },
        updateFeatures(sourceFromDropdown) {
            const sourceAllowedEventsNames = sourceFromDropdown.events.map(({name}) => name);
            const currentSourceFeatureNames = sourceFromDropdown.features.filter((unfilteredFeature) => unfilteredFeature.isActive).map((feature) => feature.name);
            const eventsOrderObject = this.currentBoard.eventsOrder.map((eventName) => this.allEvents.find((event) => event.name === eventName));
            const isForceUpdate = this.currentBoard.currentSource.name !== sourceFromDropdown.name;
            this.tempCurrentSourceEventsNames = [];
            this.currentBoard.currentSource = sourceFromDropdown;
            this.currentBoard.features = getFeaturesWithData().filter((feature) => currentSourceFeatureNames.includes(feature.name));
            this.currentBoard.events = Object.freeze(eventsOrderObject.filter((event) => sourceAllowedEventsNames.includes(event.name)));
            this.currentBoard.allEvents = Object.freeze(_.cloneDeep(this.currentBoard.events));
            this.sessionEventsOrder = Object.freeze(_.cloneDeep(this.currentBoard.eventsOrder));
            this.$emit('updateDashboardData', 'updateFeatures', isForceUpdate, true);
        },
        updateDashboardData(methodName, forceUpdate = false, isUpdateCache = true) {
            this.$emit('updateDashboardData', methodName, forceUpdate, isUpdateCache);
        },
        saveTempFeaturesNamesWidth(countOfNewEvents) {
            if (!this.currentBoard.temp) {
                this.currentBoard.temp = {};
            }
            this.currentBoard.featuresData.forEach((feature) => {
                if (!this.currentBoard.temp[feature.name]) {
                    this.currentBoard.temp[feature.name] = {};
                }
                this.currentBoard.temp[feature.name].newEventsCount = countOfNewEvents;
            });
        },
        updateEvents(events, justDeletedEvents, justAddedEvents, deletedEvents) {
            this.currentBoard.deletedEvents = deletedEvents;
            this.currentBoard.events = Object.freeze(events);
            const eventsNames = events.map((e) => e.name);
            const areNewEventsAdded = !isIncludesAll(this.savedData.events, eventsNames);

            justDeletedEvents.forEach((columnName) => {
                changeFeaturesWidthOnColumnWidth(this.currentBoard.featuresData, this.featuresSettings, this.currentBoard.allEventsAndAllFormulas, columnName, -1);
            });
            if (areNewEventsAdded) {
                this.saveTempFeaturesNamesWidth(eventsNames.length - this.savedData.events.length);
                this.$nextTick(() => {
                    this.updateDashboardData('updateEvents', true);
                });
            } else if (justAddedEvents.length) {
                justAddedEvents.forEach((columnName) => {
                    changeFeaturesWidthOnColumnWidth(this.currentBoard.featuresData, this.featuresSettings, this.currentBoard.allEventsAndAllFormulas, columnName, 1);
                });
                this.updateDeletedEventsAndFormulasIndexes();
            } else {
                this.updateDeletedEventsAndFormulasIndexes();
            }
            this.updateStateForBoards('updateEvents');
        },
        updateDeletedEventsAndFormulasIndexes() {
            const localIndexes = [];
            this.currentBoard.deletedEvents.forEach((delName) => {
                const index = this.currentBoard.allEventsAndAllFormulas.findIndex((all) =>
                    all.name === delName.name);
                if (index >= 0) {
                    localIndexes.push(index);
                }

            });
            if (this.currentBoard.deletedFormulas) {
                this.currentBoard.deletedFormulas.forEach((delName) => {
                    const index = this.currentBoard.allFormulas.findIndex((all) => all.name === delName.name);
                    const formulasIndex = this.currentBoard.allEvents.length + index;
                    if (index >= 0) {
                        localIndexes.push(formulasIndex);
                    }
                });
            }
            this.currentBoard.deletedEventsAndFormulasIndexes = localIndexes; // todo freeze
            this.$emit('updateHiddenColumnsStyles', localIndexes);
        },
        swapEvents(swapEventsOrderFirstIndex, swapEventsOrderSecondIndex) {
            const events = _.cloneDeep(this.currentBoard.events);
            const eventsOrder = _.cloneDeep(this.currentBoard.eventsOrder);
            const allEvents = _.cloneDeep(this.currentBoard.allEvents);
            const sessionEventsOrder = _.cloneDeep(this.sessionEventsOrder);
            const swapFirstName = eventsOrder[swapEventsOrderFirstIndex];
            let swapSecondName;
            const isFirstEventExistInSource = this.currentBoard.currentSource.events.find((event) => event.name === swapFirstName);
            if (isFirstEventExistInSource) {
                if (swapEventsOrderFirstIndex < swapEventsOrderSecondIndex) {
                    for (let i = swapEventsOrderSecondIndex; i > swapEventsOrderFirstIndex; i--) {
                        const swapSecondObject = this.currentBoard.currentSource.events.find((event) => event.name
                            === eventsOrder[i]);
                        if (swapSecondObject) {
                            swapSecondName = swapSecondObject.name;
                            break;
                        }
                    }
                } else {
                    for (let i = swapEventsOrderSecondIndex; i < swapEventsOrderFirstIndex; i++) {
                        const swapSecondObject = this.currentBoard.currentSource.events.find((event) => event.name
                            === eventsOrder[i]);
                        if (swapSecondObject) {
                            swapSecondName = swapSecondObject.name;
                            break;
                        }
                    }
                }
            }

            function getIndexes(firstIndex, secondIndex) {
                if (firstIndex < secondIndex) {
                    return {
                        first: firstIndex,
                        second: secondIndex + 1,
                        delete: firstIndex,
                    };
                }
                return {
                    first: firstIndex,
                    second: secondIndex,
                    delete: firstIndex + 1,
                };
            }

            function swapByIndexes(indexes, eventsArray) {
                const newEventsArray = _.cloneDeep(eventsArray);
                newEventsArray.splice(indexes.second, 0, eventsArray[indexes.first]);
                newEventsArray.splice(indexes.delete, 1);
                return newEventsArray;
            }

            this.currentBoard.eventsOrder = Object.freeze(swapByIndexes(getIndexes(swapEventsOrderFirstIndex,
                swapEventsOrderSecondIndex), eventsOrder));
            const swapSessionEventsOrderFirstIndex = this.sessionEventsOrder.findIndex((eventsOrder) => eventsOrder === swapFirstName);
            const swapSecondSessionEventsOrder = swapSecondName || eventsOrder[swapEventsOrderSecondIndex];
            const swapSessionEventsOrderSecondIndex = this.sessionEventsOrder.findIndex((eventsOrder) => eventsOrder === swapSecondSessionEventsOrder);
            this.sessionEventsOrder = Object.freeze(swapByIndexes(getIndexes(swapSessionEventsOrderFirstIndex, swapSessionEventsOrderSecondIndex), sessionEventsOrder));

            if (isFirstEventExistInSource && swapFirstName && swapSecondName) {
                const swapFirstIndex = events.findIndex((event) => event.name === swapFirstName);
                const swapSecondIndex = events.findIndex((event) => event.name === swapSecondName);
                const swapAllEventsFirstIndex = allEvents.findIndex((allEvent) => allEvent.name === swapFirstName);
                const swapAllEventsSecondIndex = allEvents.findIndex((allEvent) => allEvent.name === swapSecondName);

                const allEventsIndexes = getIndexes(swapAllEventsFirstIndex, swapAllEventsSecondIndex);
                this.currentBoard.events = Object.freeze(swapByIndexes(getIndexes(swapFirstIndex, swapSecondIndex), events));
                this.currentBoard.allEvents = Object.freeze(swapByIndexes(allEventsIndexes, allEvents));

                this.currentBoard.featuresData = swapFeaturesColumns(this.currentBoard.featuresData, allEventsIndexes.first, allEventsIndexes.second, allEventsIndexes.delete);
                this.currentBoard.allEventsAndAllFormulas = [...this.currentBoard.allEvents, ...this.currentBoard.allFormulas];
                if ((this.currentBoard.deletedEvents && this.currentBoard.deletedEvents.length) || (this.currentBoard.deletedFormulas && this.currentBoard.deletedFormulas.length)) {
                    this.updateDeletedEventsAndFormulasIndexes();
                }
                this.$emit('swapHeaderInFeatures', swapFirstIndex, swapSecondIndex);
                this.$emit('updateColumnsColorStyles');
                this.$emit('rerenderFeaturesAfterSwap', allEventsIndexes);
            }
            this.updateStateForBoards('swapEvents');
        },
        clickAttributesRow(option) {
            const yOffset = document.querySelector('.dashboard-settings-line').clientHeight + 75;
            const element = document.querySelector(`.VFeatureBlock-${option.name}`);
            if (element) {
                const y = element.getBoundingClientRect().top + window.pageYOffset - yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
            }
        },
        catchAttributesEvent(event, isAdd) {
            const optionText = event.target.querySelector('.VFilter-dropdown-row__option').innerHTML.toLowerCase().trim();
            const highlightElement = document.querySelector(`.VFeatureBlock-${optionText}`);
            if (highlightElement) {
                if (isAdd) {
                    highlightElement.classList.add('VFeatureBlock_highlight');
                } else {
                    highlightElement.classList.remove('VFeatureBlock_highlight');
                }
            }
        },
        createEventListeners() {
            window.addEventListener('scroll', this.changeShadowVisibility, false);
        },
        removeEventListeners() {
            window.removeEventListener('scroll', this.changeShadowVisibility, false);
        },
        changeTopPanelVisibillity() {
            this.$emit('update:isShowTopPanel', !this.isShowTopPanel);
            setTimeout(() => {
                this.changeShadowVisibility();
            }, 375);
        },
        changeShadowVisibility() {
            if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
                document.querySelector('.dashboard-settings-line').classList.add('dashboard-settings-line_sticked');
            } else {
                document.querySelector('.dashboard-settings-line').classList.remove('dashboard-settings-line_sticked');
            }
        },
        prepareFeatureFilter() {
            const selectedRowsNames = [];
            const featureArrayIndex = this.currentBoard.features.findIndex((feature) => feature.name ===
                this.currentBoard.featuresData[this.featureFiltersId].name);
            this.currentBoard.featuresData[this.featureFiltersId].rows.forEach((row) => {
                if (this.currentBoard.featuresData[this.featureFiltersId].selectedIds.includes(row.uniqueId)) {
                    selectedRowsNames.push(row.value);
                }
            });
            this.$emit('updateFeatureFiltersId', null);
            if (this.currentBoard.featuresData[this.featureFiltersId].name === 'Summary') {
                this.$emit('applyFilterSummaryTable', selectedRowsNames);
            } else {
                this.$emit('applyFeatureFilter', featureArrayIndex, selectedRowsNames);
            }

        },
        removeFilter(filterRemovedIndex) {
            const newFilters = _.cloneDeep(this.boards[this.activeBoardIndex].filters);
            newFilters.splice(filterRemovedIndex, 1);
            this.boards[this.activeBoardIndex].filters = Object.freeze(newFilters);
            this.updateDashboardData('Removed filters', true);
        },
        returnDateFromHistory() {
            const datesFromHistory = this.currentBoard.componentsSettings.dateTimeHistory.splice(-1, 1)[0];
            this.updateDateTimePicker(datesFromHistory);
        },
        updateDateTimePickerAndSaveHistory(newDatePeriod) {
            if (JSON.stringify(newDatePeriod) !== JSON.stringify(this.currentBoard.datePeriod)) {
                this.currentBoard.componentsSettings.dateTimeHistory = updateTimeHistory(this.currentBoard.datePeriod, this.currentBoard.componentsSettings.dateTimeHistory);
                this.updateDateTimePicker(newDatePeriod);
            }
        },
        updateDateTimePicker(newDatePeriod) {
            this.currentBoard.datePeriod = newDatePeriod;
            this.updateDashboardData('VDateTimeSelectPicker-datePeriod');
        },
        clearAllFilters() {
            this.currentBoard.filters = [];
            this.updateDashboardData('clearAllFilters', true);
        },
        showTooltip(event, name, data) {
            this.$emit('showTooltip', event, name, data);
        },
        updateSandbox() {
            this.currentBoard.sandbox = !this.currentBoard.sandbox;
            this.$nextTick(() => {
                this.updateDashboardData('updateSandbox', true);
            });
        },
        updateCohort() {
            this.currentBoard.cohort = !this.currentBoard.cohort;
            this.$nextTick(() => {
                this.updateDashboardData('updateCohort', true);
            });
        },
        findIndexAndLastActive(templateArray, currentFormulas, newObj) {
            const currentFormulasNames = this.currentBoard.formulas.map((f) => f.name);
            let index = templateArray.findIndex(item => item.name === newObj.name);

            if (index === -1) {
                return 'Object not found in array';
            }

            let lastActive = templateArray.slice(0, index).reverse().find(item =>
                currentFormulasNames.includes(item.name));
            let targetIndex = 0;
            if (lastActive) {
                const lastActiveIndex = currentFormulas.findIndex(item => item.name === lastActive.name);
                targetIndex = lastActiveIndex !== -1 ? lastActiveIndex + 1 : 0;
            }

            return {
                arrayIndex: index,
                targetIndex,
            };
        },
        addAllFormulas(formulas) {
            formulas.forEach((formula) => {
                this.addCurrentFormula(formula, false)
            })
            this.updateDeletedEventsAndFormulasIndexes();
            this.$emit('addColumnWidthForNewFormula', null);
        },
        addCurrentFormula(formula, isUpdateWidth = true) {
            const eventsLength = this.currentBoard.allEvents.length;
            const formulas = _.cloneDeep(this.currentBoard.formulas);
            if (!formula.isTemplate) {
                const length = this.currentBoard.featuresData[0].rows[0].cells.length
                this.currentBoard.featuresData = addFormulaToFeatures(
                    this.currentBoard.featuresFromResponse, this.boards[this.activeBoardIndex].featuresData,
                    this.currentBoard.events, formula, length,
                    this.currentBoard.additionalColumnsByFeatureName, this.currentBoard.arppuCoef);
                formulas.push(formula);
                this.currentBoard.allFormulas.push(formula);

            } else {
                const indexes =
                    this.findIndexAndLastActive(this.formulasTemplates, this.currentBoard.formulas, formula);
                formulas.splice(indexes.targetIndex, 0, formula);
                this.currentBoard.featuresData = addFormulaToFeatures(
                    this.currentBoard.featuresFromResponse, this.boards[this.activeBoardIndex].featuresData,
                    this.currentBoard.events, formula, indexes.targetIndex + eventsLength ,
                    this.currentBoard.additionalColumnsByFeatureName,this.currentBoard.arppuCoef);
                this.currentBoard.allFormulas.splice(indexes.targetIndex, 0, formula);
            }
            this.currentBoard.formulas = Object.freeze(formulas);
            const updateFeaturesWidthNames = [];
            if (formula.featuresNames) {
                this.currentBoard.featuresData.forEach((feature) => {
                    const featureName = feature.name.split(' ')[0];
                    const deletedFormulasNames = this.currentBoard.featuresSettings[featureName].deletedFormulasNames || [];
                    deletedFormulasNames.filter((name) => name !== formula.name);
                    this.currentBoard.featuresSettings[featureName].deletedFormulasNames = deletedFormulasNames;
                    if (!formula.featuresNames[featureName]) {
                        const deletedFormulasNames = this.currentBoard.featuresSettings[featureName].deletedFormulasNames || [];
                        deletedFormulasNames.push(formula.name);
                        this.currentBoard.featuresSettings[featureName].deletedFormulasNames = deletedFormulasNames;
                    } else {
                        updateFeaturesWidthNames.push(featureName);
                    }
                });
            }
            if (isUpdateWidth) {
                this.updateDeletedEventsAndFormulasIndexes();
                this.$emit('addColumnWidthForNewFormula', formula.featuresNames ? updateFeaturesWidthNames : null);
            }
        },
        deleteCurrentFormula(formula) {
            // changeFeaturesWidthOnColumnWidth(this.currentBoard.featuresData, this.featuresSettings, this.currentBoard.allEventsAndAllFormulas, formula.name, -1);
            const newFormulas = _.cloneDeep(this.currentBoard.formulas.filter((lf) => lf.name !== formula.name));
            this.currentBoard.formulas = Object.freeze(newFormulas);
            if (!this.currentBoard.deletedFormulas) {
                this.currentBoard.deletedFormulas = [];
            }
            const deletedName = `hidden-deleted_${++this.deletedFormulasIndex}`;
            const deletedFormula = _.cloneDeep(formula);
            deletedFormula.name = deletedName;
            const allFormulaDeleted = this.currentBoard.allFormulas.find((lf) => lf.name === formula.name);
            allFormulaDeleted.name = deletedName;
            this.currentBoard.deletedFormulas.push(deletedFormula);
            this.updateDeletedEventsAndFormulasIndexes();
            const updateFeaturesWidthNames = [];
            if (formula.featuresNames) {
                this.currentBoard.featuresData.forEach((feature) => {
                    const featureName = feature.name.split(' ')[0];
                    if (formula.featuresNames[featureName]) {
                        updateFeaturesWidthNames.push(featureName);
                    }
                });
            }
            this.$emit('deleteColumnWidthForNewFormula', formula.featuresNames ? updateFeaturesWidthNames : null);
        },
        updateCurrentFormula(formulaIndex, formula, oldFormulaName) {
            const rowColumnIndex = this.currentBoard.events.length + formulaIndex;
            updateFeatureFormulaColumn(this.currentBoard.featuresData, rowColumnIndex, formula,
                this.currentBoard.additionalColumnsByFeatureName,this.currentBoard.arppuCoef);
            this.$emit('rerenderFeatures');
            const newFormulas = _.cloneDeep(this.currentBoard.formulas);
            const newAllFormulas = _.cloneDeep(this.currentBoard.allFormulas);
            newAllFormulas[this.currentBoard.allFormulas.findIndex((allFormula) => allFormula.name === oldFormulaName)] = formula;
            newFormulas[formulaIndex] = formula;
            this.currentBoard.allFormulas = _.cloneDeep(newAllFormulas);
            this.currentBoard.formulas = _.cloneDeep(newFormulas);
            this.$emit('updateColumnWidthForFormula', rowColumnIndex);
        },
        updateCurrentFormulaName(formulaIndex, oldFormulaName, newFormulaName) {
            const rowColumnIndex = this.currentBoard.events.length + formulaIndex;
            const newFormulas = _.cloneDeep(this.boards[this.activeBoardIndex].formulas);
            const newAllFormulas = _.cloneDeep(this.boards[this.activeBoardIndex].allFormulas);
            newFormulas[this.boards[this.activeBoardIndex].formulas.findIndex((formula) => formula.name === oldFormulaName)].name = newFormulaName;
            newAllFormulas[this.boards[this.activeBoardIndex].allFormulas.findIndex((allFormula) => allFormula.name === oldFormulaName)].name =
                newFormulaName;
            this.boards[this.activeBoardIndex].allFormulas = _.cloneDeep(newAllFormulas);
            this.boards[this.activeBoardIndex].formulas = _.cloneDeep(newFormulas);
            this.$emit('updateColumnWidthForFormula', rowColumnIndex);
        },
        updateStateForBoards(methodName, isUpdateInDb = true) {
            this.$emit('updateStateForBoards', methodName, isUpdateInDb);
        },
        swapFormulas(swapFirstIndex, swapSecondIndex) {
            const formulas = _.cloneDeep(this.currentBoard.formulas);
            const formulasOld = _.cloneDeep(this.currentBoard.formulas);
            const allFormulas = _.cloneDeep(this.currentBoard.allFormulas);

            const swapAllEventsFirstIndex = allFormulas.findIndex((allFormula) => allFormula.name ===
                formulasOld[swapFirstIndex].name);
            const swapAllEventsSecondIndex = allFormulas.findIndex((allFormula) => allFormula.name ===
                formulasOld[swapSecondIndex].name);
            const eventsLength = this.currentBoard.allEvents.length;

            function getIndexes(firstIndex, secondIndex, offset = 0) {
                if (firstIndex < secondIndex) {
                    return {
                        first: firstIndex + offset,
                        second: secondIndex + 1 + offset,
                        delete: firstIndex + offset,
                    };
                }
                return {
                    first: firstIndex + offset,
                    second: secondIndex + offset,
                    delete: firstIndex + 1 + offset,
                };
            }

            const formulasIndexes = getIndexes(swapFirstIndex, swapSecondIndex);
            formulas.splice(formulasIndexes.second, 0, formulas[formulasIndexes.first]);
            formulas.splice(formulasIndexes.delete, 1);

            const allFormulasIndexes = getIndexes(swapAllEventsFirstIndex, swapAllEventsSecondIndex);
            allFormulas.splice(allFormulasIndexes.second, 0, allFormulas[allFormulasIndexes.first]);
            allFormulas.splice(allFormulasIndexes.delete, 1);

            const allEventsAllFormulasIndexes = getIndexes(swapAllEventsFirstIndex, swapAllEventsSecondIndex, eventsLength);

            this.currentBoard.formulas = formulas;
            this.currentBoard.allFormulas = allFormulas;

            this.currentBoard.featuresData =
                swapFeaturesColumns(this.currentBoard.featuresData, allEventsAllFormulasIndexes.first,
                    allEventsAllFormulasIndexes.second, allEventsAllFormulasIndexes.delete);

            this.currentBoard.allEventsAndAllFormulas =
                [...this.currentBoard.allEvents, ...this.currentBoard.allFormulas];

            if ((this.currentBoard.deletedEvents && this.currentBoard.deletedEvents.length) ||
                (this.currentBoard.deletedFormulas && this.currentBoard.deletedFormulas.length)) {
                this.updateDeletedEventsAndFormulasIndexes();
            }
            this.updateStateForBoards('swapFormulas');
            this.$emit('swapHeaderInFeatures', swapFirstIndex + eventsLength, swapSecondIndex + eventsLength);
            this.$emit('rerenderFeaturesAfterSwap', allEventsAllFormulasIndexes);
        },
    },
};
</script>

<style
    scoped
    lang="scss"
>
.disabled {
  opacity: 0.5;
}

.dashboard {
  &-settings-line {
    &_overview {
      height: 60px;
    }

    &_source {
      height: 120px;
    }

    .dashboard-row {
      display: flex;
      padding: 0 20px;
      top: 5px;

      &_first {
        align-items: flex-start;
        margin-top: 22px;
        transition: opacity 0.3s;
        opacity: 1;

        &.collapsed {
          opacity: 0;
        }
      }

      &_second {
        background: white;
        align-items: center;
        transition: transform 0.5s;
        padding: 0 0 15px 20px;
        width: calc(100% - 40px);
        transform: translateY(59px);
        position: absolute;
        z-index: 8;

        &-hidden {
          width: 100%;
          height: 100%;
          display: flex;

          .VDateTimeSelectPicker, .filters-block, .dashboard-refresh, .dashboard-refresh_filter {
            margin-right: 20px;
          }
        }

        &.collapsed {
          transform: translateY(-6px);
        }
      }

      .VFilter, .formulas-block, .VDateTimeSelectPicker, .filters-block {
        margin-right: 20px;
      }

      ::v-deep {
        .VToggle {
          margin-right: 20px;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }


    &_sticked {
      position: sticky;
      top: 0;
      background: #FFFFFF;
      @include light-shadow;
    }

    &.collapsed {
      height: 60px;
    }
  }

  &-refresh {
    cursor: pointer;
    width: 40px;
    min-width: 40px;
    height: 40px;
    background-position: 0 0;
    background-repeat: no-repeat;
    background-image: url('data:image/svg+xml;base64,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');

    &_filter {
      cursor: pointer;
      width: 40px;
      min-width: 40px;
      height: 40px;
      background-position: 0 0;
      background-repeat: no-repeat;
      background-image: url('data:image/svg+xml;base64,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');
    }
  }

  .VFilter-count {
    font-weight: bold;
    width: 45px;
    text-align: right;
  }

  &-top-panel-switcher {
    cursor: pointer;
    width: 23px;
    min-width: 23px;
    margin-top: 10px;
    height: 22px;
    display: flex;
    align-items: center;
    background-position: 0 0;
    background-repeat: no-repeat;
    background-image: url('data:image/svg+xml;base64,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');

    &_active {
      margin-top: 10px;
      transform: rotate(-180deg);
    }
  }
}

.disabled {
  pointer-events: none;
}
</style>
